<script>

  import sgsUtils from './SgsUtils';

  import SgsRenderHeader from './SgsRenderHeader.vue'
  import SgsRenderInputText from './SgsRenderInputText.vue'
  import SgsRenderInputNumber from './SgsRenderInputNumber.vue'
  import SgsRenderInputDate from './SgsRenderInputDate.vue'
  import SgsRenderInputDateTime from './SgsRenderInputDateTime.vue'
  import SgsRenderInputTime from './SgsRenderInputTime.vue'
  import SgsRenderInputSelect from './SgsRenderInputSelect.vue'
  import SgsRenderInputMultiSelect from './SgsRenderInputMultiSelect'
  import SgsRenderInputTextArea from './SgsRenderInputTextArea'
  import SgsRenderInputButtonUpload from './SgsRenderInputButtonUpload'
  import SgsRenderInputPassword from './SgsRenderInputPassword'
  import SgsRenderInputCpf from './SgsRenderInputCpf'
  import SgsRenderInputCnpj from './SgsRenderInputCnpj'
  import SgsRenderInputEmail from './SgsRenderInputEmail'
  import SgsRenderInputCurrency from './SgsRenderInputCurrency'
  import SgsRenderLabelAndValue from './SgsRenderLabelAndValue'
  import SgsRenderInputBoolean from './SgsRenderInputBoolean'
  import SgsRenderInputDataWrapper from './SgsRenderInputDataWrapper'
  import SgsRenderButton from './SgsRenderButton.vue'
  import SgsRenderErrorList from './SgsRenderErrorList.vue'
  import SgsRenderInputFilterText from './SgsRenderInputFilterText.vue'
  import SgsRenderCollapse from './SgsRenderCollapse.vue'
  import SgsRenderInputPhoneNumber from './SgsRenderInputPhoneNumber.vue'
  import SgsRenderImage from './SgsRenderImage.vue'
  import SgsRenderInputHidden from './SgsRenderInputHidden.vue'
  import SgsRenderDashboard from './SgsRenderDashboard.vue'
  import SgsRenderLabel from './SgsRenderLabel'
  import SgsRenderGrid from './SgsRenderGrid'
  import SgsRenderMap from './SgsRenderMap'
  import SgsRenderInputDealership from './SgsRenderInputDealership'
  import SgsRenderInputCharges from './SgsRenderInputCharges'
  import SgsRenderButtonReport from './SgsRenderButtonReport.vue'
  import SgsRenderInputCsv from './SgsRenderInputCsv.vue'
  import SgsRenderTextEditor from './SgsRenderTextEditor.vue'
  import SgsRenderFloat from './SgsRenderFloat.vue'
  import SgsRenderButtonForm from './SgsRenderButtonForm.vue'
  import SgsRenderButtonPrint from './SgsRenderButtonPrint.vue'
  import SgsRenderButtonPDF from './SgsRenderButtonPDF.vue'
  import SgsRenderCustomComponent from './SgsRenderCustomComponent.vue'
  import SgsRenderFilterBoolean from './SgsRenderFilterBoolean.vue'

  export default{
    props: [
      "type", "attr", "fieldValue", "labelOnly", "rules",
      "formIdentifier", "moduleType", "instance", "attrConfig"
    ],
    components:{
      SgsRenderHeader,
      SgsRenderInputText,
      SgsRenderInputNumber,
      SgsRenderInputDate,
      SgsRenderInputDateTime,
      SgsRenderInputTime,
      SgsRenderInputSelect,
      SgsRenderInputMultiSelect,
      SgsRenderInputTextArea,
      SgsRenderInputButtonUpload,
      SgsRenderInputPassword,
      SgsRenderInputCpf,
      SgsRenderInputCnpj,
      SgsRenderInputEmail,
      SgsRenderInputCurrency,
      SgsRenderInputBoolean,
      SgsRenderLabelAndValue,
      SgsRenderInputDataWrapper,
      SgsRenderButton,
      SgsRenderErrorList,
      SgsRenderInputFilterText,
      SgsRenderCollapse,
      SgsRenderInputPhoneNumber,
      SgsRenderImage,
      SgsRenderInputHidden,
      SgsRenderDashboard,
      SgsRenderLabel,
      SgsRenderGrid,
      SgsRenderMap,
      SgsRenderInputDealership,
      SgsRenderInputCharges,
      SgsRenderButtonReport,
      SgsRenderInputCsv,
      SgsRenderTextEditor,
      SgsRenderFloat,
      SgsRenderButtonForm,
      SgsRenderButtonPrint,
      SgsRenderButtonPDF,
      SgsRenderCustomComponent,
      SgsRenderFilterBoolean
    },
    methods: {
      updateField: function(fieldName, fieldValue) {
        this.$emit('input', fieldName, fieldValue);
      },
      actionLinkSelected: function(formId, dataRow) {
        this.$emit('actionLinkSelected', formId, dataRow);
      },
      callBusinessRule: function(businessRuleId) {
        this.$emit('callBusinessRule', businessRuleId);
      },
      showHint: function() {
        return (this.attr.hintPt != undefined && this.attr.hintPt != "");
      },
      getHint: function () {
        return sgsUtils.getHint({
          attr: this.attr,
          locale: this.$i18n.locale
        });
      },
      implementedHint: function() {
        let listImplementeds = ['text'];

        return (listImplementeds.indexOf(this.type) > -1);
      },
      getLabel: function () {
        return sgsUtils.getLabel({
          attr: this.attr,
          locale: this.$i18n.locale,
          label: ""
        });
      },
      getPlaceholder: function() {
        return sgsUtils.getPlaceholder(this.attr, this.$i18n.locale);
      },
      getModuleType: function() {
        if(this.moduleType === undefined) {
          return 'form';
        }
        return this.moduleType;
      }
    },
    watch: {
      "attrConfig": function (newVal, oldVal) {
        if (newVal != undefined && this.attr != undefined ) {
          _.forOwn(newVal, (value, key) => {
            this.$set(this.attr, key, value);
          });
        }
      },
      "instance._updated": function (newVal, oldVal) {

        if (this.instance !== undefined && this.instance._config !== undefined && this.instance._config[this.attr.columnName] !== undefined) {
          if (this.instance._config[this.attr.columnName].disableField !== undefined) {
            this.attr.disableField = this.instance._config[this.attr.columnName].disableField;
          }
          if (this.instance._config[this.attr.columnName].showInForm !== undefined) {
            this.attr.showInForm = this.instance._config[this.attr.columnName].showInForm;
          }
          if (this.instance._config[this.attr.columnName].showInDetails !== undefined) {
            this.attr.showInDetails = this.instance._config[this.attr.columnName].showInDetails;
          }
          if (this.instance._config[this.attr.columnName].labelPt !== undefined) {
            this.attr.labelPt = this.instance._config[this.attr.columnName].labelPt;
          }
          if (this.instance._config[this.attr.columnName].labelEs !== undefined) {
            this.attr.labelEs = this.instance._config[this.attr.columnName].labelEs;
          }
          if (this.instance._config[this.attr.columnName].labelEn !== undefined) {
            this.attr.labelEn = this.instance._config[this.attr.columnName].labelEn;
          }
          if (this.instance._config[this.attr.columnName].dependsOfSource !== undefined) {
            this.attr.dependsOfSource = this.instance._config[this.attr.columnName].dependsOfSource;
          }
          if (this.instance._config[this.attr.columnName].dependsOfTarget !== undefined) {
            this.attr.dependsOfTarget = this.instance._config[this.attr.columnName].dependsOfTarget;
          }
        }
      }
    },
    computed: {
      showSgsRenderGrid: function () {
        if (this.attr.type === 'grid' && this.attr.showInForm !== undefined) {
          return this.attr.showInForm;
        }
        return true;
      },
      showSgsRender: function () {

        let ret = false;

        if (this.moduleType === undefined) {
          return true;
        }

        if (this.attr.type !== undefined) {

          if (this.moduleType === 'form') {
            if (this.attr.showInForm !== undefined && this.attr.type !== 'grid') {
              ret = this.attr.showInForm;
            } else {
              ret = true;
            }

          } else if (this.moduleType === 'show') {
            if (this.attr.showInDetails !== undefined ) {

              ret = this.attr.showInDetails;
            } else {
              ret = true;
            }
          } else if (this.moduleType === 'list') {
            if (this.attr.type !== undefined ) {
              ret = true;
            } else {
              ret = false;
            }
          }
        }

        return ret;
      },
      addClass: function () {
        let myClass = ""
        if (this.attr.hideOnPrint) {
          myClass += "noPrint ";
        }
        if (
          this.attr.type == "buttonReport" || this.attr.type == "inputCSV" ||
          this.attr.type == "file" || this.attr.type == "buttonForm" ||
          this.attr.type == "buttonPrint" || this.attr.type == "buttonPDF" ||
         this.attr.type == "button") {
          myClass += "displayInline ";
        }
        return myClass;
      },
    }
  }
</script>

<template>
  <div v-if="showSgsRender" v-show="showSgsRenderGrid" :class="addClass">

    <SgsRenderHeader
      v-if="type == 'header'"
      :attr="attr"
      :showHint="showHint()"
      :hintValue="getHint()"
      :label="getLabel()"
    />

    <SgsRenderCollapse
      v-if="type == 'collapse'"
      :attr="attr"
      :label="getLabel()"
    />

    <SgsRenderInputText
      v-if="type == 'text' || type == 'filterText'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :placeholder="getPlaceholder()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      @callBusinessRule="callBusinessRule"
    />

    <SgsRenderInputPassword
      v-if="type == 'password'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :placeholder="getPlaceholder()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      @callBusinessRule="callBusinessRule"
    />

    <SgsRenderInputNumber
      v-if="type == 'numeric' || type == 'filterNumeric'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      @callBusinessRule="callBusinessRule"
    />

    <SgsRenderInputDate
      v-if="type == 'date' || type == 'filterDate'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :placeholder="getPlaceholder()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      @callBusinessRule="callBusinessRule"
    />

    <SgsRenderInputDateTime
      v-if="type == 'dateTime'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :placeholder="getPlaceholder()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      @callBusinessRule="callBusinessRule"
    />

    <SgsRenderInputTime
      v-if="type == 'time'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :placeholder="getPlaceholder()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      @callBusinessRule="callBusinessRule"
    />

    <SgsRenderInputTextArea
      v-if="type == 'textArea'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :placeholder="getPlaceholder()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      @callBusinessRule="callBusinessRule"
    />

    <SgsRenderInputBoolean
      v-if="type == 'boolean'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :showHint="showHint()"
      :label="getLabel()"
      :placeholder="getPlaceholder()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      @callBusinessRule="callBusinessRule"
    />

    <SgsRenderInputCpf
      v-if="type == 'cpf'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :placeholder="getPlaceholder()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      @callBusinessRule="callBusinessRule"
    />

    <SgsRenderInputCnpj
      v-if="type == 'cnpj'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :placeholder="getPlaceholder()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      @callBusinessRule="callBusinessRule"
    />

    <SgsRenderInputEmail
      v-if="type == 'email'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :placeholder="getPlaceholder()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      @callBusinessRule="callBusinessRule"
    />

    <SgsRenderInputDataWrapper
      v-if="type == 'association' || type == 'composition'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :formIdentifier="formIdentifier"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :placeholder="getPlaceholder()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      :instance="instance"
      @callBusinessRule="callBusinessRule"
      :disableField="attr.disableField"
    />

    <SgsRenderInputPhoneNumber
      v-if="type == 'phone'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :placeholder="getPlaceholder()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      @callBusinessRule="callBusinessRule"
    />

    <SgsRenderFile
      v-if="type == 'file'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :showHint="showHint()"
      :label="getLabel()"
      :placeholder="getPlaceholder()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      :formIdentifier="formIdentifier"
    />

    <SgsRenderInputCurrency
      v-if="type == 'currency'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :placeholder="getPlaceholder()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      @callBusinessRule="callBusinessRule"
    />

	  <SgsRenderImage
      v-if="type == 'image'"
      :attr="attr"
    />

    <SgsRenderInputHidden
      v-if="type == 'hidden'"
      :attr="attr"
    />

	<SgsRenderDashboard
      v-if="type == 'dashboard'"
      :attr="attr"
      :fieldValue="fieldValue"
      @callBusinessRule="callBusinessRule"
    />

    <SgsRenderLabel
      v-if="type == 'label'"
      :attr="attr"
      :showHint="showHint()"
      :hintValue="getHint()"
      :label="getLabel()"
      :fieldValue="fieldValue"
    />

    <SgsRenderGrid
      v-if="type == 'grid'"
      :attr="attr"
      :formIdentifier="formIdentifier"
      :instance="instance"
      :fieldValue="fieldValue"
      @actionLinkSelected="actionLinkSelected"
    />

    <SgsRenderMap
      v-if="type == 'map'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      @callBusinessRule="callBusinessRule">
    </SgsRenderMap>

    <SgsRenderInputDealership
      v-if="type == 'dealership'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :placeholder="getPlaceholder()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      @callBusinessRule="callBusinessRule"
    >
    </SgsRenderInputDealership>

    <SgsRenderInputCharges
      v-if="type == 'charges'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :placeholder="getPlaceholder()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      @callBusinessRule="callBusinessRule"
    >
    </SgsRenderInputCharges>

    <SgsRenderButtonReport
      v-if="type == 'buttonReport'"
      :attr="attr"
      :instance="instance"
      @callBusinessRule="callBusinessRule"
      :formIdentifier="formIdentifier"
      :label="getLabel()"
    >
    </SgsRenderButtonReport>

    <SgsRenderInputCsv
      v-if="type == 'inputCSV'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      @callBusinessRule="callBusinessRule"
    >
    </SgsRenderInputCsv>

    <SgsRenderTextEditor
      v-if="type == 'textEditor'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
      @callBusinessRule="callBusinessRule"
    >
    </SgsRenderTextEditor>

    <SgsRenderFloat
      v-if="type == 'float'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :placeholder="getPlaceholder()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
    >
    </SgsRenderFloat>

    <SgsRenderButtonForm
      v-if="type == 'buttonForm'"
      :label="getLabel()"
      :attr="attr"
      :formId="attr.formId"
      @actionLinkSelected="actionLinkSelected"
      :instance="instance"
    >
    </SgsRenderButtonForm>

    <SgsRenderButtonPrint
      v-if="type == 'buttonPrint'"
      :attr="attr"
      :label="getLabel()"
      @callBusinessRule="callBusinessRule">
    </SgsRenderButtonPrint>

    <SgsRenderButtonPDF
      v-if="type == 'buttonPDF'"
      :attr="attr"
      :label="getLabel()"
      :instance="instance">
    </SgsRenderButtonPDF>

    <SgsRenderFilterBoolean
      v-if="type == 'filterBoolean'"
      :attr="attr"
      @updateFieldValue="updateField"
      :fieldValue="fieldValue"
      :rules="rules ? rules : []"
      :showHint="showHint()"
      :label="getLabel()"
      :placeholder="getPlaceholder()"
      :hintValue="getHint()"
      :moduleType="getModuleType()"
    />

    <!--TODO COMPONENTES NÃO REFATORADOS-->

    <SgsRenderButton
      v-if="type == 'button'"
      :attr="attr"
      @callBusinessRule="callBusinessRule"
      :label="getLabel()"
    />

    <SgsRenderErrorList v-if="type == 'errorList'" :fieldValue="fieldValue"/>

    <SgsRenderInputSelect v-if="type == 'select'" :attr="attr" @updateFieldValue="updateField" :fieldValue="fieldValue" />
    <SgsRenderInputMultiSelect v-if="type == 'multiSelect'" :attr="attr" @updateFieldValue="updateField" :fieldValue="fieldValue" />
    <SgsRenderInputButtonUpload v-if="type == 'upload'" :attr="attr" @updateFieldValue="updateField" :fieldValue="fieldValue" />
    <SgsRenderCustomComponent
      v-if="type == 'customComponent'"
      :attr="attr"
      :instance="instance"
      :formIdentifier="formIdentifier"
      @callBusinessRule="callBusinessRule"
    />
  </div>
</template>



// WEBPACK FOOTER //
// SgsRender.vue?186bf968